import React from 'react';
import '../styles/pages/WebsiteStructure.css';

const WebsiteStructure = () => {
  // Lista wszystkich podstron ze struktury
  const pages = [
    {
      name: "Strona główna",
      path: "index.html",
      level: "main-page",
      keywords: [
        "doradztwo finansowe",
        "kredyty gotówkowe",
        "kredyty hipoteczne",
        "pośrednik kredytowy",
        "najlepsze kredyty",
        "porównanie ofert kredytowych"
      ],
      elements: [
        "Banner główny z hasłem przewodnim (H1: \"Profesjonalne doradztwo finansowe i najlepsze oferty kredytowe\")",
        "Krótka prezentacja korzyści: szybka decyzja, minimum formalności, wsparcie ekspertów",
        "Sekcja \"Nasze usługi\" z linkami do poszczególnych podstron produktowych",
        "Wezwania do działania: formularz kontaktowy, numer telefonu, przycisk \"Złóż wniosek\"",
        "Sekcja \"Partnerzy\" - logotypy banków: PKO BP, Santander, BNP Paribas, PEKAO",
        "Sekcja z opiniami klientów (karuzela z najlepszymi opiniami)"
      ]
    },
    {
      name: "Kredyty gotówkowe",
      path: "kredyty-gotowkowe.html",
      level: "subpage-level-1",
      keywords: [
        "kredyt gotówkowy",
        "szybki kredyt gotówkowy",
        "kredyt na dowolny cel",
        "kredyt bez zabezpieczeń",
        "najniższe oprocentowanie kredytu",
        "najtańszy kredyt gotówkowy",
        "oprocentowanie kredytów gotówkowych"
      ],
      elements: [
        "Nagłówek H1: \"Kredyty gotówkowe - najkorzystniejsze oferty na rynku\"",
        "Wprowadzenie do kredytów gotówkowych - czym są i na co można je przeznaczyć",
        "Porównanie aktualnych ofert z różnych banków",
        "Interaktywny kalkulator kredytowy",
        "Wymagania i warunki uzyskania kredytu",
        "Proces wnioskowania krok po kroku",
        "Formularz kontaktowy z konsultantem",
        "FAQ - najczęściej zadawane pytania"
      ]
    },
    {
      name: "Kredyty hipoteczne",
      path: "kredyty-hipoteczne.html",
      level: "subpage-level-1",
      keywords: [
        "kredyt hipoteczny",
        "kredyt na zakup mieszkania",
        "kredyt na budowę domu",
        "najlepszy kredyt hipoteczny",
        "porównanie kredytów hipotecznych",
        "wkład własny kredyt hipoteczny",
        "zdolność kredytowa kredyt hipoteczny"
      ],
      elements: [
        "Nagłówek H1: \"Kredyty hipoteczne - profesjonalne doradztwo i najlepsze oferty\"",
        "Rodzaje kredytów hipotecznych",
        "Koszty kredytu hipotecznego - oprocentowanie, prowizje, ubezpieczenia",
        "Kalkulator zdolności kredytowej",
        "Porównanie aktualnych ofert bankowych",
        "Proces wnioskowania o kredyt hipoteczny",
        "Lista wymaganych dokumentów (z możliwością pobrania)",
        "Formularz kontaktowy",
        "Case studies - przykłady zrealizowanych kredytów"
      ]
    },
    {
      name: "Kredyty konsolidacyjne",
      path: "kredyty-konsolidacyjne.html",
      level: "subpage-level-1",
      keywords: [
        "kredyt konsolidacyjny",
        "konsolidacja kredytów",
        "konsolidacja chwilówek",
        "obniżenie raty kredytu",
        "połączenie kredytów",
        "jak połączyć kilka kredytów",
        "konsolidacja zadłużenia"
      ],
      elements: [
        "Nagłówek H1: \"Kredyty konsolidacyjne - połącz swoje zobowiązania i obniż miesięczną ratę\"",
        "Wyjaśnienie korzyści z konsolidacji kredytów",
        "Kalkulator oszczędności przy konsolidacji",
        "Porównanie ofert kredytów konsolidacyjnych",
        "Wymagania i warunki uzyskania",
        "Case studies - przykłady udanych konsolidacji (przed/po)",
        "Informacje o konsolidacji chwilówek",
        "Formularz kontaktowy"
      ]
    },
    {
      name: "Kredyty dla Firm",
      path: "kredyty-dla-firm.html",
      level: "subpage-level-1",
      keywords: [
        "kredyt firmowy",
        "kredyt inwestycyjny",
        "kredyt obrotowy",
        "finansowanie działalności",
        "kredyt dla przedsiębiorców",
        "kredyt na rozwój firmy",
        "kredyt na zakup maszyn"
      ],
      elements: [
        "Nagłówek H1: \"Kredyty dla firm - finansowanie rozwoju Twojego biznesu\"",
        "Rodzaje kredytów dla firm (inwestycyjne, obrotowe)",
        "Wymagania wobec przedsiębiorców",
        "Porównanie ofert kredytów firmowych",
        "Kalkulator kredytowy dla firm",
        "Proces wnioskowania i niezbędne dokumenty",
        "Referencje od klientów biznesowych",
        "Formularz kontaktowy"
      ]
    },
    {
      name: "Leasing",
      path: "leasing.html",
      level: "subpage-level-1",
      keywords: [
        "leasing operacyjny",
        "leasing finansowy",
        "leasing samochodowy",
        "leasing maszyn",
        "porównanie ofert leasingu",
        "korzyści podatkowe leasingu",
        "leasing czy kredyt firmowy"
      ],
      elements: [
        "Nagłówek H1: \"Leasing - elastyczne finansowanie pojazdów i maszyn dla Twojej firmy\"",
        "Różnice między leasingiem operacyjnym a finansowym",
        "Korzyści podatkowe leasingu",
        "Porównanie leasingu z kredytem firmowym",
        "Oferty leasingowe dla samochodów, maszyn i urządzeń",
        "Kalkulator leasingowy",
        "Proces wnioskowania o leasing",
        "Formularz kontaktowy"
      ]
    },
    {
      name: "Produkty pozabankowe",
      path: "produkty-pozabankowe.html",
      level: "subpage-level-1",
      keywords: [
        "pożyczki pozabankowe",
        "kredyt bez BIK",
        "pożyczka dla zadłużonych",
        "kredyt z komornikiem",
        "pożyczka dla firm bez BIK",
        "szybka pożyczka pozabankowa"
      ],
      elements: [
        "Nagłówek H1: \"Produkty pozabankowe - finansowanie dla osób z trudniejszą sytuacją kredytową\"",
        "Rodzaje produktów pozabankowych",
        "Porównanie wiarygodnych firm pożyczkowych",
        "Wymagania i warunki uzyskania",
        "Ostrzeżenia przed niebezpiecznymi ofertami (wysokie koszty)",
        "Porady dla osób zadłużonych",
        "Alternatywy dla pożyczek pozabankowych",
        "Formularz kontaktowy"
      ]
    },
    {
      name: "Upadłość konsumencka",
      path: "upadlosc-konsumencka.html",
      level: "subpage-level-1",
      keywords: [
        "upadłość konsumencka",
        "oddłużanie",
        "pomoc dla zadłużonych",
        "wyjście z długów",
        "postępowanie upadłościowe",
        "jak ogłosić upadłość konsumencką",
        "warunki upadłości konsumenckiej"
      ],
      elements: [
        "Nagłówek H1: \"Upadłość konsumencka - szansa na nowy start finansowy\"",
        "Czym jest upadłość konsumencka",
        "Warunki ogłoszenia upadłości konsumenckiej",
        "Proces postępowania upadłościowego krok po kroku",
        "Koszty postępowania upadłościowego",
        "Skutki ogłoszenia upadłości",
        "Alternatywy dla upadłości konsumenckiej",
        "Formularz konsultacyjny"
      ]
    },
    {
      name: "Sankcje Kredytu Darmowego",
      path: "sankcje-kredytu-darmowego.html",
      level: "subpage-level-1",
      keywords: [
        "sankcja kredytu darmowego",
        "zwrot kosztów kredytu",
        "nieprawidłowości w umowie kredytowej",
        "sankcja kredytowa",
        "błędy w umowie kredytowej",
        "odzyskiwanie kosztów kredytu"
      ],
      elements: [
        "Nagłówek H1: \"Sankcje Kredytu Darmowego - sprawdź czy możesz odzyskać koszty kredytu\"",
        "Czym jest sankcja kredytu darmowego",
        "Podstawy prawne sankcji kredytu darmowego",
        "Najczęstsze nieprawidłowości w umowach kredytowych",
        "Proces dochodzenia praw kredytobiorcy",
        "Przykłady wygranych spraw (kwoty, okoliczności)",
        "Formularz do weryfikacji umowy kredytowej",
        "FAQ - najczęstsze pytania"
      ]
    },
    {
      name: "Doradztwo finansowe",
      path: "doradztwo-finansowe.html",
      level: "subpage-level-1",
      keywords: [
        "doradztwo finansowe",
        "planowanie finansowe",
        "optymalizacja finansów",
        "analiza zdolności kredytowej",
        "doradca finansowy",
        "kompleksowe doradztwo finansowe"
      ],
      elements: [
        "Nagłówek H1: \"Profesjonalne doradztwo finansowe - kompleksowa pomoc w zarządzaniu finansami\"",
        "Czym jest doradztwo finansowe",
        "Zakres usług doradztwa finansowego",
        "Korzyści z korzystania z usług doradcy",
        "Proces współpracy z doradcą finansowym",
        "Sylwetki doradców (zdjęcia, doświadczenie)",
        "Referencje od klientów",
        "Formularz umówienia konsultacji"
      ]
    },
    {
      name: "O nas",
      path: "o-nas.html",
      level: "subpage-level-1",
      keywords: [
        "eksperci finansowi",
        "doświadczeni doradcy kredytowi",
        "zaufane doradztwo finansowe",
        "licencjonowany pośrednik kredytowy",
        "doświadczony pośrednik kredytowy"
      ],
      elements: [
        "Nagłówek H1: \"O nas - kim jesteśmy i jak pomagamy naszym klientom\"",
        "Historia firmy i lata doświadczenia",
        "Misja i wartości firmy",
        "Licencje i certyfikaty (KNF, rejestr pośredników)",
        "Zespół ekspertów (zdjęcia, biogramy)",
        "Banki partnerskie (PKO BP, Santander, BNP Paribas, PEKAO)",
        "Dlaczego warto wybrać naszą firmę",
        "Osiągnięcia i statystyki (liczba klientów, kwoty kredytów)"
      ]
    }
  ];

  return (
    <div className="website-structure-page">
      <div className="container">
        <header className="page-header">
          <h1>Struktura Logiczna Strony - Tabela</h1>
          <p>Podstrony, ich organizacja i słowa kluczowe pod które należy optymalizować treść</p>
        </header>

        <div className="info-box">
          <p>
            Poniżej znajduje się szczegółowa struktura strony internetowej dla firmy finansowej, 
            zawierająca zalecaną organizację stron, słowa kluczowe i elementy zawartości.
            Struktura została zaprojektowana, aby maksymalizować widoczność w wyszukiwarkach
            i zapewnić logiczną nawigację dla użytkowników.
          </p>
        </div>

        <div className="table-container">
          <table className="structure-table">
            <thead>
              <tr className="header-row">
                <th style={{ width: "25%" }}>Nazwa podstrony</th>
                <th style={{ width: "25%" }}>Słowa kluczowe</th>
                <th style={{ width: "50%" }}>Elementy / zawartość</th>
              </tr>
            </thead>
            <tbody>
              {pages.map((page, index) => (
                <tr key={index} className={page.level}>
                  <td>
                    <span className="page-level">{page.name}</span><br />
                    <code>{page.path}</code>
                  </td>
                  <td>
                    <div className="keywords-container">
                      {page.keywords.map((keyword, kidx) => (
                        <span key={kidx} className="keyword">{keyword}</span>
                      ))}
                    </div>
                  </td>
                  <td className="elements">
                    <ul>
                      {page.elements.map((element, eidx) => (
                        <li key={eidx}>{element}</li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WebsiteStructure;